import React, { useState, useRef  } from 'react';
import './login.css'
import GoogleLogo from './Asset/google.png';
import AppleLogo from './Asset/apple-logo.png';
import Logo from "../NavBar/Asset/New_Assert/ESO_Logo.png";
import PasswordRestGif from './Asset/On_Board/resetpassword.gif';
import axios from "axios";
import Loader from "../NavBar/CommonLoader";
import { useSelector } from "react-redux";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {Container, Box} from '@mui/material';
import Grid from '@mui/material/Grid';

const PasswordReset=()=>{



  const [loading, setLoading] = useState(false);
  const esodata = useSelector((state) => state);
  const ApiToken = esodata.apiauthkey.value;
    const emailPhonepsrstRef = useRef(null);
    const [errors, setErrors] = useState({
        emailPhoneerr: '',
      });
    const [formData, setFormData] = useState({
        emailPhone: '',
      });
      const SmthandleChangerst = (e) => {
        const { name, value } = e.target;
        setFormData({
          ...formData,
          [name]: value,
        });
      
        setErrors({
          ...errors,
          [name]: '',
        });
      };
    const PasswordReset =async (e) => {
        e.preventDefault();

        const { emailPhonepsrst} = formData;
        const phoneNumberRegex = /^[0-9]{10}$/;
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const newErrors = {};
        var Errorcheck=0;
       
        if (!emailPhonepsrst || emailPhonepsrst.length === 0) {
          newErrors.emailPhoneerr = "Please enter your email address.";
          Errorcheck=1
          emailPhonepsrstRef.current.focus();
        } else if (!emailRegex.test(emailPhonepsrst)) {
          newErrors.emailPhoneerr = "Please enter a valid email address.";
          Errorcheck=1;
          emailPhonepsrstRef.current.focus();
        }
        setErrors(newErrors);

        if(Errorcheck===0)
        {

          setLoading(true)

          try{

            const Response = await axios.post(
              `${process.env.REACT_APP_API_URL}accounts/password_reset_link/`,
              {
                email: emailPhonepsrst,
                redirect_url:process.env.REACT_APP_DOMAIN+'reset-password'
              },     
            );

            if(Response.data)
            {
               if(Response.data.status==='success')
               {
                setFormData({})

                var inputElement = document.querySelector('[name="emailPhonepsrst"]');
                inputElement.value=''

                toast.success('Password reset link has been sent to your given email address. Kindly check!', {
                  position: "top-center",
                  autoClose: 5000,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                  theme: "light",
                  });

               }
            }
  
         

          }catch(err)
          {

    
            var valuesForKey=[];
            var valuesForKeyN=[];
            var valuesForKeyE=[];

            if(err.response.data.error_list)
            {
               valuesForKey = err.response.data.error_list.map(obj => String(obj['error']));
            }
            if(err.response.data.non_field_errors)
            {
               valuesForKeyN = err.response.data.non_field_errors
            }
            if(err.response.data.email)
            {
              valuesForKeyE = err.response.data.email
            }
             
            valuesForKey=valuesForKey.concat(valuesForKeyN);
            valuesForKey=valuesForKey.concat(valuesForKeyE);
            valuesForKey=valuesForKey.join(',')
            setLoading(false)
            toast.error(valuesForKey, {
              position: "top-center",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
              });
          }
         

          setLoading(false)


        }




      };

    return (
        <>
              {loading === true ? <Loader /> : null}
    <ToastContainer
position="top-center"
autoClose={5000}
hideProgressBar={false}
newestOnTop={false}
closeOnClick
rtl={false}
pauseOnFocusLoss
draggable
pauseOnHover
theme="light"
/>
<div>
            {/* <div className='tab_otr_outer reset_page_container'>
    <div className='tab_head_container_lft'>
    <div className='tab_head_innr_container'>
    <img src={Logo} className="login_tab_img" alt="ESO logo"/>
        <div className='tab_head_container_outr rest_container'>
          <h1 className='tab_header'>Reset your password</h1>
          <div className='frm_otr_wrap'>
          <div className='frm_inner_wrap'>
          <form onSubmit={PasswordReset} className='frm_container' method="post">
          <div class="form-group email_grp">
            <input type="text" id="email_Phone" name="emailPhonepsrst" placeholder='Email address' value={formData.emailPhonepsrst} onChange={SmthandleChangerst} ref={emailPhonepsrstRef} />
            <div className="frm_error">{errors.emailPhoneerr}</div>
          </div>
            <button type="submit" className='sbt_btn'>Send me reset link</button>
            </form>
           
        </div>
        <div><a href="/login" className='lgn_rdrct_link'>Go back to login</a></div> 
        </div>

        </div>

        </div>
        </div>
        <div className='tab_head_container_right'>
      <div className='das_tab_container'><img src={PasswordRestGif} className="PasswordRestGif" alt="left image" /></div>
     </div>
        </div> */}

          <div className="reset_page_container">
            {/* Left Side - Form */}
            <div className="reset_left">
              <div className="form_wrapper">
                <img src={Logo} className="login_logo" alt="ESO logo" />
                <h1 className="form_title">Reset your password</h1>
                <form onSubmit={PasswordReset} className="reset_form" method="post">
                  <div className="form-group">
                    <input style={{ height: "45px" }}
                      type="text"
                      id="email_Phone"
                      className='reset_form_input'
                      name="emailPhonepsrst"
                      placeholder="Email address"
                      value={formData.emailPhonepsrst}
                      onChange={SmthandleChangerst}
                      ref={emailPhonepsrstRef}
                    />
                    <div className="form_error">{errors.emailPhoneerr}</div>
                  </div>
                  <button type="submit" className="submit_btn">Send me reset link</button>
                </form>

                <a href="/login" className="back_to_login">Go back to login</a>
              </div>
              <Container maxWidth={false} className="footer-container footor-bottom-fixed">
                <Box className="footer-box">
                  <Grid container className="footer-grid">
                    <Grid item xs={12} md={12}>
                      <div className="footer-left">
                        <p className="footer-text" style={{ textAlign: "center" }}>
                          All Rights Reserved Copyright © 2025 |
                          <a href="https://www.egrovesys.com/" target="blank">
                            <span className="footer-brand"> eGrove Systems</span>
                          </a>
                        </p>
                      </div>
                    </Grid>

                  </Grid>
                </Box>
              </Container>
            </div>
            <div className="reset_right">
              <img src={PasswordRestGif} className="reset_image" alt="Reset illustration" />
            </div>
          </div>

        </div>
        </>
       
    );
}
export default PasswordReset;